/* ============================================================
   MUSSONY — no auto-open cart + gentle confirmation toast.
   The Opus/EGO app force-opens its cart drawer (#opus-shadow-container, shadow
   DOM) on every /cart/add. This script:
     1) suppresses ONLY that auto-open (keeps the drawer veiled and keeps issuing
        the app's own close until it stays shut, so no flash / no stuck drawer);
     2) shows a small Polish toast "Dodano do koszyka ✓" with a "Zobacz koszyk"
        link (error toast on failure), reusing one element (no stacking);
     3) hides the theme's native add banner so there is no double confirmation.
   Manual cart-icon clicks and in-drawer upsell adds still open the drawer
   normally; scrolling is never left locked. The header cart count keeps updating
   via the theme/app as usual.
   Reversible: delete this file + its <script> tag in layout/theme.liquid.
   Added June 2026 — CRO (no auto-open cart).
   18.08.2026 — loaded at the end of <body> instead of <head> (speed fix).
   ============================================================ */
(function () {
  if (window.__mussonyNoAutoCart) return;
  window.__mussonyNoAutoCart = true;

  var armed = false, closing = false, fallbackTimer = null, toastTimer = null;
  var TOAST_MS = 2600;

  function host()  { return document.getElementById('opus-shadow-container'); }
  function sroot() { var h = host(); return h && h.shadowRoot; }
  function isOpen(){
    var s = sroot();
    return !!(s && s.querySelector('.opus-drawer-container.open')) ||
           document.body.classList.contains('opus-modal-open');
  }

  var st = document.createElement('style');
  st.textContent =
    'html.mussony-no-autocart #opus-shadow-container{visibility:hidden !important;pointer-events:none !important;}'
  + 'buy-buttons .banner--success,buy-buttons .banner--error{display:none !important;}'
  + '#mussony-toast{position:fixed;left:50%;bottom:calc(86px + env(safe-area-inset-bottom,0px));transform:translateX(-50%) translateY(10px);background:#1c1c1c;color:#fff;padding:12px 18px;border-radius:10px;display:flex;flex-wrap:wrap;justify-content:center;gap:6px 16px;align-items:center;font-size:14px;line-height:1.25;z-index:2147483600;opacity:0;visibility:hidden;transition:opacity .25s,transform .25s,visibility .25s;box-shadow:0 8px 28px rgba(0,0,0,.28);max-width:92vw}'
  + '#mussony-toast.show{opacity:1;visibility:visible;transform:translateX(-50%) translateY(0)}'
  + '#mussony-toast .ms-msg{white-space:nowrap}'
  + '#mussony-toast .ms-link{color:#fff;text-decoration:underline;white-space:nowrap;font-weight:600;cursor:pointer}'
  + '#mussony-toast.err{background:#cb2b2b}';
  (document.head || document.documentElement).appendChild(st);
  function veil(on) { document.documentElement.classList[on ? 'add' : 'remove']('mussony-no-autocart'); }

  function closeOnce() {
    var s = sroot();
    if (s) {
      var b = s.querySelector('button.opus-drawer-container-close');
      if (b) { try { b.click(); } catch (e) {} }
      var ov = s.querySelector('.cd-app-overlay');       if (ov) ov.classList.remove('cd-app-overlay-open');
      var dc = s.querySelector('.opus-drawer-container'); if (dc) dc.classList.remove('open');
    }
    document.body.classList.remove('opus-modal-open');
    document.body.style.removeProperty('overflow');
  }
  function endSuppress() {
    armed = false; closing = false; veil(false);
    if (fallbackTimer) { clearTimeout(fallbackTimer); fallbackTimer = null; }
  }
  function suppressLoop() {
    if (!armed) return;
    if (!isOpen()) { endSuppress(); return; }
    closeOnce();
    setTimeout(suppressLoop, 120);
  }
  function onOpen() { if (armed && !closing && isOpen()) { closing = true; suppressLoop(); } }
  function arm() {
    if (isOpen()) return;
    armed = true; closing = false; veil(true);
    if (fallbackTimer) clearTimeout(fallbackTimer);
    fallbackTimer = setTimeout(endSuppress, 8000);
  }

  try { new MutationObserver(onOpen).observe(document.body, { attributes: true, attributeFilter: ['class', 'style'] }); } catch (e) {}
  function obsShadow() {
    var s = sroot();
    if (s) { try { new MutationObserver(onOpen).observe(s, { subtree: true, attributes: true, attributeFilter: ['class'] }); } catch (e) {} return true; }
    return false;
  }
  /* MUSSONY 18.08.2026 (speed fix): the poll used to run 60 times x 200ms = 12s of
     timer work on every page view. The app's shadow root either exists within the
     first few seconds or the app is not on the page at all, so 15 tries (3s) is
     enough and frees the main thread during the critical window. */
  if (!obsShadow()) { var n = 0, iv = setInterval(function () { if (obsShadow() || ++n > 15) clearInterval(iv); }, 200); }

  function ensureToast() {
    var t = document.getElementById('mussony-toast');
    if (t) return t;
    t = document.createElement('div'); t.id = 'mussony-toast';
    t.setAttribute('role', 'status'); t.setAttribute('aria-live', 'polite');
    var m = document.createElement('span'); m.className = 'ms-msg';
    var a = document.createElement('a'); a.className = 'ms-link'; a.href = '#'; a.textContent = 'Zobacz koszyk';
    t.appendChild(m); t.appendChild(a); document.body.appendChild(t);
    a.addEventListener('click', function (e) {
      e.preventDefault();
      endSuppress();
      var c = document.querySelector('a[href$="/cart"]') || document.querySelector('a[href*="/cart"]');
      if (c) { c.click(); } else { location.href = '/cart'; }
    });
    return t;
  }
  function showToast(msg, err) {
    var t = ensureToast();
    t.querySelector('.ms-msg').textContent = msg;
    t.classList.toggle('err', !!err);
    t.querySelector('.ms-link').style.display = err ? 'none' : '';
    t.classList.add('show');
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('show'); }, TOAST_MS);
  }

  function isAdd(u) { return typeof u === 'string' && u.indexOf('/cart/add') > -1; }
  var of = window.fetch;
  window.fetch = function () {
    var a = arguments[0]; var u = (a && a.url) || a; var add = isAdd(u); var wasOpen = add && isOpen();
    if (add && !wasOpen) arm();
    var p = of.apply(this, arguments);
    if (add && !wasOpen) {
      p.then(function (res) {
        try { showToast(res && res.ok ? 'Dodano do koszyka ✓' : 'Nie udało się dodać do koszyka', !(res && res.ok)); } catch (e) {}
        return res;
      }).catch(function () {});
    }
    return p;
  };
  var oo = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, u) {
    if (isAdd(u)) {
      var x = this; var wasOpen = isOpen();
      if (!wasOpen) {
        x.addEventListener('loadstart', arm, { once: true });
        x.addEventListener('load', function () { try { showToast(x.status >= 200 && x.status < 300 ? 'Dodano do koszyka ✓' : 'Nie udało się dodać do koszyka', !(x.status >= 200 && x.status < 300)); } catch (e) {} }, { once: true });
      }
    }
    return oo.apply(this, arguments);
  };
})();

/* ============================================================
   MUSSONY — quick size add in product cards (roadmap #10, August 2026).
   Each size in a card is a submit button of that card's product form. On click
   we copy the button's variant id into the form's hidden "id" input, so the
   theme's own <product-form> performs the add-to-cart exactly as it does on the
   product page (and the toast above confirms it). Capture phase, so the value is
   set before the theme's submit handler reads the form.
   Reversible: delete this block; the size buttons then simply add the first
   available variant.
   ============================================================ */
(function () {
  if (window.__mussonySizeAdd) return;
  window.__mussonySizeAdd = true;

  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest ? event.target.closest('[data-mussony-size]') : null;
    if (!button || button.disabled) return;

    var form = button.form || button.closest('form');
    if (!form) return;

    var input = form.querySelector('[data-mussony-variant-input]');
    if (input) input.value = button.getAttribute('data-variant-id');

    button.setAttribute('data-added', 'true');
    setTimeout(function () { button.removeAttribute('data-added'); }, 1600);
  }, true);
})();

/* ============================================================
   MUSSONY — reveal the size bar on narrow product cards (roadmap #10).
   On narrow cards the size strip is an overlay over the bottom of the photo and
   the theme's "+" button opens it instead of the quick-buy modal. On wide cards
   the strip is laid out inline and the "+" is hidden, so this handler stands
   down — it detects the mode from the strip's computed position rather than
   from a breakpoint, which keeps it in sync with the container query.
   ============================================================ */
(function () {
  if (window.__mussonySizeToggle) return;
  window.__mussonySizeToggle = true;

  var OPEN = 'data-sizes-open';

  function closeAll(except) {
    var open = document.querySelectorAll('product-card[' + OPEN + ']');
    for (var i = 0; i < open.length; i++) {
      if (open[i] !== except) open[i].removeAttribute(OPEN);
    }
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var trigger = target.closest('.product-card__quick-add-button');
    if (trigger) {
      var card = trigger.closest('product-card');
      var strip = card && card.querySelector('.product-card__sizes--interactive');

      /* MUSSONY 18.08.2026 (dead-click fix): the strip was only tested for its
         computed position, so a strip that exists in the DOM but is not rendered
         (display:none, detached, inside a collapsed card) still matched. We then
         called preventDefault + stopPropagation and swallowed the tap: the theme
         never received the click and nothing happened on screen. Clarity recorded
         ~60 such dead clicks a day on the Ecru lace cards on 17.08.
         offsetParent === null means the element is not rendered, so in that case
         we now stand down and let the theme handle the click as usual. */
      if (strip && strip.offsetParent !== null &&
          getComputedStyle(strip).position === 'absolute') {
        event.preventDefault();
        event.stopPropagation();

        var wasOpen = card.hasAttribute(OPEN);
        closeAll(card);
        if (wasOpen) { card.removeAttribute(OPEN); } else { card.setAttribute(OPEN, ''); }
        return;
      }
    }

    if (target.closest('[data-mussony-size]')) {
      setTimeout(function () { closeAll(null); }, 400);
      return;
    }

    closeAll(null);
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAll(null);
  });
})();
